import React, { useEffect, useState } from "react";
import { clBasic, sizeFiltros } from "./general"

export default function ListaOpciones({ setFiltro, lista, elemento, titulo, absolute }) {
  if (absolute === undefined) { absolute = 0 }
  const [contexto, setContexto] = useState({ visible: false, x: 0, y: 0 });

  const SlistaSeleccion = {
    minWidth: "140px",
    color: clBasic,
    textAlign: "left",
    position: "fixed",
    top: `${contexto.y}px`,
    left: `${contexto.x + 5}px`,
    zIndex: 7,
    background: "white",
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: "5px",
    padding: "5px",
    maxHeight: "400px",
    overflowY: "auto",
  };
  const ScampoSeleccion = {
    height: "25px",
    fontSize: "13px",
    listStyleType: "none",
    cursor: "pointer",
  };

  function selecciono(e) {
    setFiltro(e.currentTarget.attributes["value"].nodeValue);
  }

  useEffect(() => {
    document.getElementById(elemento).addEventListener("click", (e) => {
      e.preventDefault();
      if (!absolute) {
        setContexto({ visible: true, x: e.clientX, y: e.clientY });
      } else {
        setContexto({ visible: true, x: e.clientX - 150, y: e.clientY - e.target.getClientRects()[0].top + 15 });
      }

    });
    document.getElementById(`listaO${elemento}`).addEventListener("click", (e) => {
      if (e.target.id === `listaOpciones${elemento}`) {
        setContexto({ visible: false, x: 0, y: 0 });
      }
    });
  }, [elemento, absolute]);

  function drop(e) {
    if (e.target.id === `listaOpciones${elemento}`) {
      e.persist();
      setContexto((c) => ({ ...c, x: e.clientX - 50, y: e.clientY - 50 }));
    }
  }

  function listaOpciones() {
    return (
      <div
        id={`listaOpciones${elemento}`}
        style={SlistaSeleccion}
        draggable="true"
        onDragEnd={(e) => drop(e)}
        onMouseEnter={(e) => {
          e.currentTarget.style.cursor = "cell";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.cursor = "";
        }}
      >
        <div style={Stitulo}>{titulo}</div>
        <div style={Slista}>
          {Object.keys(lista).map((key) => {
            return (
              <li
                style={ScampoSeleccion}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = clBasic;
                  e.currentTarget.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "white";
                  e.currentTarget.style.color = clBasic;
                }}
                value={lista[key]}
                key={key}
                onClick={(e) => {
                  selecciono(e);
                  setContexto({ visible: false, x: 0, y: 0 });
                }}
                onDoubleClick={(e) => {
                  selecciono(e);
                }}
              >
                {key}
              </li>
            );
          })}
        </div>
      </div>
    );
  }

  return <div id={`listaO${elemento}`}>{contexto.visible ? listaOpciones() : null}</div>;
}

const Stitulo = {
  fontSize: sizeFiltros,
  fontWeight: 500,
  borderBottom: "dotted gray thin",
  cursor: "default",
  textAlign: "center"
};

const Slista = {
  margin: "10px 5px 10px 5px",
  maxHeight: "150vh",
  overflowY: "auto",

};
